/**
 * Build the gateway `send` payload from the host's optional `systemPreamble`,
 * the user's typed `content`, and optional per-message `messageContext`.
 *
 * Contract: the chat bubble/title always show the raw `content`; only the
 * outbound gateway payload carries the preamble and the message context. Both
 * extras are hidden the same way — appended to the wire payload, never to the
 * visible transcript.
 *
 * `messageContext` is per-call hidden context (e.g. the structured data for a
 * `/analyze`d trade) — distinct from `systemPreamble`, which is static and
 * rides on every turn. Ordering on the wire is preamble → content → context:
 * identity, then the user's ask, then the reference data for it. Blank /
 * whitespace-only extras are dropped so we never send `"   \n\n<msg>"`.
 */
export function buildSendPayload(
  systemPreamble: string | undefined,
  content: string,
  messageContext?: string,
): string {
  const parts: string[] = [];
  if (systemPreamble != null && systemPreamble.trim().length > 0) {
    parts.push(systemPreamble);
  }
  parts.push(content);
  if (messageContext != null && messageContext.trim().length > 0) {
    parts.push(messageContext);
  }
  return parts.join('\n\n');
}
